import { type WebsiteCardView } from './card-summary';
import { useArtStyleCard } from './cards/art-style/useArtStyleCard';
import { useBlogCard } from './cards/blog/useBlogCard';
import { useCreativesCard } from './cards/creatives/useCreativesCard';
import { useGamesCard } from './cards/games/useGamesCard';
import { useLogosCard } from './cards/logos/useLogosCard';
import { useSeoCard } from './cards/seo/useSeoCard';
import { WEBSITE_TABS, type WebsiteTab, type WebsiteTabId } from './tabs';

/**
 * The Website hub's cards: one per area, in the areas' own order, each with the hook that reads its data and
 * returns what the card shows. A new area joins by adding its tab, its hook here and its colours in the tokens;
 * the `Record` types make a missing entry a compile error.
 */

export type WebsiteCardDef = WebsiteTab & { useSummary: () => WebsiteCardView };

export const SUMMARY_HOOKS: Record<WebsiteTabId, () => WebsiteCardView> = {
  creatives: useCreativesCard,
  logos: useLogosCard,
  'art-style': useArtStyleCard,
  games: useGamesCard,
  blog: useBlogCard,
  seo: useSeoCard,
};

export const WEBSITE_CARDS: readonly WebsiteCardDef[] = WEBSITE_TABS.map((tab) => ({
  ...tab,
  useSummary: SUMMARY_HOOKS[tab.id],
}));

/** The cards to show, in order: each shows under exactly the flag that shows its area. */
export const visibleWebsiteCards = (isEnabled: (key: string | undefined) => boolean): WebsiteCardDef[] =>
  WEBSITE_CARDS.filter((card) => isEnabled(card.flag));
